import Vue from 'vue';
import VueResource from 'vue-resource';
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import isFunction from 'lodash/isFunction';
import config from 'config';
import router from '../router';

Vue.use(VueResource);
Vue.use(LoadingPlugin);

Vue.http.options.crossOrigin = true;
Vue.http.options.xhr = { withCredentials: true };

function logger(method, url, data, token, result) {
const styles = {
method: 'color: #dd1c65',
url: 'color: #000',
data: 'color: #4CAF50',
token: 'color: #4CAF50',
result: 'color: #03A9F4'
};
console.group(`%c ${method} %c ${url}`, styles.method, styles.url);
console.log(`%c data`, styles.data, data);
console.log(`%c token`, styles.token, { token: { token } });
console.log(`%c result`, styles.result, result);
console.groupEnd();
}

const qsString = (body) => {

let str = '';
let split = '';
let i = 0;
for (let k in body) {
const v = body[k];
if (v != undefined) {
if (i++ != 0) {
split = '&';
}
str += split + k + '=' + v;
}
}
return str;
};

class Request {
constructor(host) {
this.host = host;
['post', 'put', 'patch', 'get', 'delete', 'head', 'jsonp'].forEach((method) => {
this[method] = (url, body, options) => {
return this.fetch(url, body || {}, { method, ...options });
};
});
}

async fetch(
url,
body,
{
host = this.host,
method,
cache = false,
jsonBody = false,
loading = true,
skipAuth = false,
enterprise = () => (config.enterprise ? '/' + config.enterprise : G.enterprise ? '/' + G.enterprise : '')
}
) {
let res;
let result;
let options = {
headers: {}
};
try {
host = host || config.hosts.mall;


if (url.indexOf(host) > -1) {
url = url.substr(host.length);
}

if (host === config.hosts.mall) {
url = (isFunction(enterprise) ? enterprise() : enterprise.length > 0 ? '/' + enterprise : enterprise) + url;
}
url = host + url;

if (loading) {
Vue.$vux.loading.hide();
Vue.$vux.loading.show({
text: '加载中'
});
}

if (method === 'get') {
if (body && Object.keys(body).length > 0) {
url = url + (url.indexOf('?') != -1 ? '&' : '?') + qsString(body);
}
}
const token = config.token || G.member.token;
options = {
headers: {
token: config.token || G.member.token,



'Content-Type': jsonBody ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded'
},
timeout: 0,
emulateJSON: !jsonBody
};

if (['get', 'delete', 'head', 'jsonp'].indexOf(method) != -1) {
res = await Vue.http[method](url, options);
}
if (['post', 'put', 'patch'].indexOf(method) != -1) {
res = await Vue.http[method](url, body, options);
}

loading && Vue.$vux.loading.hide();

if (res.ok == true) {
result = await res.json();

if (result.code == -10) {
logger(method, url, body, options.headers.token, result);
console.log('======== token 过期 或者 错误 =========');
G.member = undefined;
localStorage.removeItem(G.enterprise);







}
if (result.code == -20) {
const url = encodeURIComponent(window.location.href);
console.log(config.hosts.mall + `/${G.enterprise}/api/h5/wechat/snsapi_base?webUrl=${url}&isPlatform=${G.is_platform !== undefined ? G.is_platform : 0}&token=${token}`);
location.href = config.hosts.mall + `/${G.enterprise}/api/h5/wechat/snsapi_base?webUrl=${url}&isPlatform=${G.is_platform !== undefined ? G.is_platform : 0}&token=${token}`;
return;
}
} else {
result = { code: -1, msg: '请求失败' };
}
logger(method, url, body, options.headers.token, result);
return result;
} catch (err) {
console.debug('err in request::', err);
loading && Vue.$vux.loading.hide();
result = { code: -2, msg: err.message };
logger(method, url, body, options.headers.token, result);
return result;
}
}
}

const RQ = {
get(url, data, host, opts) {
return new Request(host).get(url, data, opts);
},
post(url, data, host, opts) {
return new Request(host).post(url, data, opts);
},
put(url, data, host, opts) {
return new Request(host).put(url, data, opts);
},
delete(url, data, host, opts) {
return new Request(host).delete(url, data, opts);
}
};

Object.keys(config.hosts).forEach((v) => {
RQ[v] = new Request(config.hosts[v]);
});

export default RQ;



// WEBPACK FOOTER //
// ./src/utils/request.js